import { getTrafficSourceSParameter } from '../trafficSource';
import config from '@cof/ukweb-config/lib/clientConfig';
import { useBrand } from '../../BrandContext';
import partners from '../../partners';
import * as constants from 'node:constants';
import { allowedUpstreams } from '../constants';

const validVendorCode = (vendorCode: any) => (/^[0-9A-Za-z]{3,}$/.test(vendorCode) ? vendorCode : undefined);

const vendorCodeFromSParameter = (sParameter: any) => sParameter?.substring(8, 11)?.replace('x', '');

const resolveSParameter = (urlSParameter: any, brand: any) => urlSParameter || getTrafficSourceSParameter(brand);

const useQueryParams = () => {
    const brand = useBrand();

    const getSearchParameter = function (parameter: any) {
        const query = new URLSearchParams(window.location.search);
        return query.get(parameter) || undefined; // undefined is added because query.get returns null if not found
    };

    const getHashedParameter = function (parameter: any) {
        if (window.location.hash !== undefined) {
            const hashParams = new URLSearchParams(window.location.hash.substring(1));
            return hashParams.get(parameter);
        }
        return undefined;
    };

    const productId = getSearchParameter('p') || (brand === partners.LUMA && 'CCS83') || undefined;

    const sParameter = resolveSParameter(getSearchParameter('s'), brand);
    const sVendorCode = vendorCodeFromSParameter(sParameter);

    const oemc = validVendorCode(getSearchParameter('o'));

    const vendorCode = validVendorCode(getSearchParameter('v')) || validVendorCode(sVendorCode);

    const result = {
        sParameter,
        quotation: getSearchParameter('quotation'),
        productId,
        vendorCode,
        oemc,
        pcr: getSearchParameter('pcr'),
        campaign: getSearchParameter('campaign'),
        channel: getSearchParameter('channel'),
        btNotOffered: !!getSearchParameter('btnotoffered'),
        firstName: getHashedParameter('firstName'),
        lastName: getHashedParameter('lastName'),
        skipDefinitions: getSearchParameter('skipDefinitions'),
        upstreamTarget: undefined
    };

    if (config.get('features.referrals')) {
        // @ts-expect-error TS2339: Property 'referral' does not exist on type ' sParameter: string | undefined; quotation: string | und
        result.referral = getSearchParameter('referral');
    }

    if (config.get('features.allowCustomUpstream')) {
        const rawUpstreamTarget = getSearchParameter('upstreamTarget');
        // @ts-expect-error TS2339: Property 'referral' does not exist on type ' sParameter: string | undefined; quotation: string | und
        result.upstreamTarget = allowedUpstreams.includes(rawUpstreamTarget) ? rawUpstreamTarget : undefined;
    }

    return result;
};

export default useQueryParams;
